import * as React from 'react';
import antd from 'antd';
import styled from 'styled-components';
import ScreenHelper from '../../Styled/ScreenHelper';
import { ColSize } from 'antd/lib/col';

const { Row, Col } = antd;
declare type ColSpanType = ColSize;

export const GenColLayout: { [key: string]: ColSpanType } = {
    xs: { span: 22 },
    sm: { span: 22 },
    md: { span: 22 },
    lg: { span: 7 },
    xl: { span: 9 }
};

export const StatusHistoryColLayout: { [key: string]: ColSpanType } = {
    xs: { span: 22 },
    sm: { span: 22 },
    md: { span: 22 },
    lg: { span: 8 },
    xl: { span: 8 }
};

export const TrackedBolDetailRow = styled(Row)`
  
    .rowDetail{
        ${ScreenHelper.down('md')`
        margin-bottom: 1em;
    `}

    .statusHistoryTitle{
        font-weight: bold;
        font-size: 16px;
    }

    .statusHistoryRow{
        text-align: left;
        margin-top: 5; 
        background-color: #f8f8f8;
        padding: 10px;
    }
}
`;


